// extracted by mini-css-extract-plugin
module.exports = {"logo":"logo--2SrXX","decorate":"decorate--1ANZm"};